import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

const workspaceInit = {
  selectedGroup: '',
  directedFromDashView: false,
  selectedDashs: [],
  isRecentsOpen: false,
  trashDashboardRedirect: false,
  refreshNonce: 0,
  refreshNonceTimeout: null,
};

function workspaceReducer(draft, { type, payload }) {
  switch (type) {
    case 'setSelectedGroup': {
      draft.selectedGroup = payload;
      break;
    }
    case 'setSelectedDashs': {
      draft.selectedDashs = payload;
      break;
    }
    case 'setIsRecentsOpen': {
      draft.isRecentsOpen = payload;
      break;
    }
    case 'setDirectedFromDashView': {
      draft.directedFromDashView = payload;
      break;
    }
    case 'setTrashDashboardRedirect': {
      draft.trashDashboardRedirect = payload;
      break;
    }
    case 'bumpRefreshNonceDebounced': {
      // Clear any pending timeout to prevent multiple timers
      if (draft.refreshNonceTimeout) {
        clearTimeout(draft.refreshNonceTimeout);
        draft.refreshNonceTimeout = null;
      }
      
      // Set new timeout
      const timeoutId = setTimeout(() => {
        draft.refreshNonce += 1;
        draft.refreshNonceTimeout = null;
      }, 100); // 100ms debounce
      
      draft.refreshNonceTimeout = timeoutId;
      break;
    }
    case 'bumpRefreshNonce': {
      // Immediate bump (for when needed)
      draft.refreshNonce += 1;
      break;
    }
    case 'clearRefreshNonceTimeout': {
      // Clear any pending timeout to prevent memory leaks
      if (draft.refreshNonceTimeout) {
        clearTimeout(draft.refreshNonceTimeout);
        draft.refreshNonceTimeout = null;
      }
      break;
    }
    default: {
      return null;
    }
  }
}

export const WorkspaceContext = createContext(null);
export const WorkspaceDispatchContext = createContext(null);

export default function WorkspaceProvider({ children }) {
  const [store, dispatch] = useImmerReducer(workspaceReducer, workspaceInit);

  return (
    <WorkspaceContext.Provider value={store}>
      <WorkspaceDispatchContext.Provider value={dispatch}>
        {children}
      </WorkspaceDispatchContext.Provider>
    </WorkspaceContext.Provider>
  );
}

export function useWorkspaceStore() {
  return useContext(WorkspaceContext);
}

export function useWorkspaceDispatch() {
  return useContext(WorkspaceDispatchContext);
}
